// extracted by mini-css-extract-plugin
export var chatHtmlText = "_nv-2";
export var chatLink = "_nv-0";
export var chatText = "_nv-1";